// extracted by mini-css-extract-plugin
export default {"logoContainer":"Brand_logoContainer__nUGm+","logoLink":"Brand_logoLink__QG9hY","logo":"Brand_logo__yjDGy"};